<template>
  <div class="dropdown-container">
    <DropdownPrime 
      v-model="selectedValue" 
      :options="options" 
      optionLabel="Glosa" 
      optionValue="Id"
      placeholder="Colegio" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-bind:[tooltipDirective]="tooltip" 
      @change="emitSelection"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'; // Asegúrate de incluir watch
import ColegioService from '@/services/ColegioService'; // Importa el servicio

export default {
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Number,
      default: null
    }
  },
  setup(props, { emit }) {
    const options = ref([]);
    const selectedValue = ref(props.modelValue);

    const fetchOptions = async () => {
      try {
        const response = await ColegioService.get(); // Llama al método getColegios
        options.value = response.data; // Asegúrate de que la respuesta tenga la estructura correcta
      } catch (error) {
        console.error('Error al cargar opciones:', error);
      }
    };

    const emitSelection = () => {
      emit('update:modelValue', selectedValue.value);
    };

    onMounted(() => {
      fetchOptions();
    });

    // Observa los cambios en modelValue para actualizar selectedValue
    watch(() => props.modelValue, (newValue) => {
      selectedValue.value = newValue;
    });

    return {
      options,
      selectedValue,
      emitSelection
    };
  }
}
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
}
</style>